import React from "react";
import "./AddButton.scss";
import Icon from "../Icon";

export default function AddButton({ text, style,color, backgroundColor, onClick, icon, className }) {
  return (
    <button className={className ? "c-add-btn " + className : "c-add-btn"} style={style?style:{ backgroundColor: backgroundColor ? backgroundColor : "#FFC415"}} onClick={onClick}>
      <div className="c-add-icon">
        <Icon icon={icon ? icon : "plus-circle"} stroke={color} />
      </div>
      <p style={color ? { color: color } : { color: "#443712" }}>{text ? text : "Enter"}</p>
    </button>
  );
}
